import { IonContent, IonPage, IonText } from "@ionic/react"
import { useEffect, useState } from "react"
import { useHistory } from "react-router"
import Head from "../../Header"
import Sidebar from "../../Sidebar"

const HRApproval: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
          history.push("/login");
        } else {
        }
      }, [token, history]);
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <IonText>Hellooo</IonText>
                </div>
            </IonContent>
        </IonPage>

    )

}

export default HRApproval